export var CostProduct;
(function (CostProduct) {
    CostProduct["COST_PRODUCT_UNSPECIFIED"] = "UNSPECIFIED";
    CostProduct["COST_PRODUCT_BACKUP"] = "BACKUP";
    CostProduct["COST_PRODUCT_STORAGE_GATEWAY"] = "STORAGE_GATEWAY";
})(CostProduct || (CostProduct = {}));
